export default class DtoUserRole {
	constructor(obj) {
		this.login = obj.login
		this.roleId = obj.roleId
	}
}



// WEBPACK FOOTER //
// ./src/home/dto/DtoUserRole.js